import { Suspense, useEffect, useState } from "react";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";

import routes from "@/app/routes";
import { Spinner, Tabs } from "@yaradigitallabs/ahua-react";
import Sidebar from "@/components/Sidebar";
import { getClassNames } from "@/utils/helpers";

import SoftTagPage from "./soft-tag";
import HomePage from "./home";

const sidebarRoutes = [
  {
    id: "home",
    text: "Home",
    icon: "Home",
    selected: true,
    iconTrailing: "Home",
    url: routes.HOME,
  },
  {
    id: "soft-tags",
    text: "Self Service",
    icon: "Article",
    selected: true,
    iconTrailing: "Home",
    url: routes.SOFT_TAG_MANAGER,
  },
];

const Layout = ({ isAuthenticated }: { isAuthenticated: boolean }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [selected, setSelected] = useState("");

  // Sync sidebar highlight with current URL — no selection on home
  useEffect(() => {
    const match = sidebarRoutes.find((r) =>
      r.url === routes.HOME
        ? location.pathname === routes.HOME
        : location.pathname.startsWith(r.url),
    );
    setSelected(match ? match.url : "");
  }, [location.pathname]);

  // Navigate when sidebar item is clicked
  const handleSidebarSelect = (url: string) => {
    setSelected(url);
    navigate(url);
  };

  // Tab state management
  const [activeTab, setActiveTab] = useState(() => {
    if (location.pathname === routes.SOFT_TAG_MANAGER) return "soft-tags";
    return "soft-tags";
  });

  // Handle tab clicks
  const handleTabClick = (tab: string) => {
    if (tab === "soft-tags") {
      navigate(routes.SOFT_TAG_MANAGER);
    }
  };

  // Update active tab based on current location
  useEffect(() => {
    if (location.pathname === routes.SOFT_TAG_MANAGER) {
      setActiveTab("soft-tags");
    }
  }, [location.pathname]);

  const isHomePage = location.pathname === routes.HOME;

  return (
    <section className="flex flex-row mt-14">
      <Sidebar
        routes={sidebarRoutes}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        selected={selected}
        setSelected={handleSidebarSelect}
      />
      <div
        className={getClassNames(
          isAuthenticated
            ? `transition-margin ${
                !collapsed
                  ? "duration-500 ease-out  min-w-[calc(100vw-192px)]"
                  : "duration-300 ease-in min-w-[calc(100vw-80px)]"
              }`
            : "",
          "min-h-content",
        )}
      >
        {/* Tabs Section — only shown outside the home page */}
        {!isHomePage && (
          <div className="pt-4 pb-2">
            <div className="px-4">
              <Tabs
                value={activeTab}
                onValueChange={setActiveTab}
                defaultValue="soft-tags"
              >
                <Tabs.List aria-label="Components">
                  <Tabs.Trigger
                    value="soft-tags"
                    onClick={() => handleTabClick("soft-tags")}
                  >
                    Soft Tags
                  </Tabs.Trigger>
                </Tabs.List>
              </Tabs>
            </div>
          </div>
        )}

        {/* Content Section */}
        <Suspense fallback={<Spinner />}>
          <Routes>
            <Route index element={<HomePage />} />
            <Route path={routes.SOFT_TAG_MANAGER} element={<SoftTagPage />} />
          </Routes>
        </Suspense>
      </div>
    </section>
  );
};
export default Layout;
